import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { UtilisateurService } from './utilisateur.service';
import { ParcoursFormationPilotageModel } from 'src/models/pilotage/parcoursFormationPilotageModel';
import { ParcoursFormationDetailPilotageModel } from 'src/models/pilotage/parcoursFormationDetailPilotageModel';
import { ParcoursFormationUtilisateurModel } from 'src/models/parcoursFormationUtilisateurModel';
import { ContexteParcoursFormation } from 'src/models/contexteParcoursFormationModel';

@Injectable({
  providedIn: 'root'
})
export class ParcoursFormationService {
  private baseUrl = environment.api_LMS + 'ParcoursFormation';

  constructor(private http: HttpClient, private translateService: TranslateService, private authService: AuthService, private utilisateurService: UtilisateurService) { }

  obtenirParcoursFormations(): Observable<ParcoursFormationPilotageModel[]> {
    const utilisateurId = this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId;
    const entiteId = this.utilisateurService.entiteUtilisateurSelectionnee.entiteId;
    const params = {
      entiteId: entiteId.toString(),
      utilisateurId: utilisateurId.toString()
    };

    return this.http.get<ParcoursFormationPilotageModel[]>(`${this.baseUrl}/ObtenirParcoursFormations`, { params });
  }

  obtenirContexte(): Observable<ContexteParcoursFormation> {
    const utilisateurId = this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId;
    const entiteId = this.utilisateurService.entiteUtilisateurSelectionnee.entiteId;

    return this.http.get<ContexteParcoursFormation>(
      `${this.baseUrl}/ObtenirContexteParcoursFormation`,
      { params: { entiteId: entiteId.toString(), utilisateurId: utilisateurId.toString() } }
    );
  }

  obtenirParcoursFormationsPourUnUtilisateurId(langue: string): Observable<ParcoursFormationUtilisateurModel[]> {
    const utilisateurId = this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId;
    const codeLangue = this.translateService.currentLang ? this.translateService.currentLang : 'fr';

    return this.http.get<ParcoursFormationUtilisateurModel[]>(`${this.baseUrl}/ObtenirParcoursFormationsPourUnUtilisateurId`, {
      params: {
        utilisateurId: utilisateurId.toString(),
        codeLangue: codeLangue
      }
    });
  }

  obtenirParcoursFormation(parcoursFormationId: number): Observable<ParcoursFormationDetailPilotageModel> {
    const utilisateurId = this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId;
    const entiteId = this.utilisateurService.entiteUtilisateurSelectionnee.entiteId;
    return this.http.get<ParcoursFormationDetailPilotageModel>(`${this.baseUrl}/ObtenirParcoursFormation`, {
      params: {
        parcoursFormationId: parcoursFormationId.toString(),
        entiteId: entiteId.toString(),
        utilisateurId: utilisateurId.toString()
      }
    });
  }

  creerParcoursFormation(model: any): Observable<void> {
    model.creePar = this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId;
    model.entiteId = this.utilisateurService.entiteUtilisateurSelectionnee.entiteId;
    return this.http.post<void>(`${this.baseUrl}/CreerParcoursFormation`, model);
  }

  modifierParcoursFormation(model: any): Observable<void> {
    model.modifiePar = this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId;
    return this.http.put<void>(`${this.baseUrl}/ModifierParcoursFormation`, model);
  }

  supprimerParcoursFormation(parcoursFormationId: number): Observable<void> {
    const retirePar = this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId;
    return this.http.put<void>(`${this.baseUrl}/SupprimerParcoursFormation?parcoursFormationId=${parcoursFormationId}&retirePar=${retirePar}`, null);
  }

  exporterParcoursFormation(parcoursFormationId: number, codeLangue: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/ExporterParcoursFormation`, {
      params: { parcoursFormationId: parcoursFormationId.toString(), codeLangue },
      responseType: 'blob'
    });
  }

  getNomLocaliseFromLocales(locales: { [lang: string]: string }): string {
    const currentLang = this.translateService.currentLang || 'fr';
    return (
      locales?.[currentLang] ||
      locales?.['fr'] ||
      locales?.['en'] ||
      locales?.['es'] ||
      ''
    );
  }

  getNomLocaliseFromStrings(nomFR: string, nomEN: string, nomES: string): string {
    const currentLang = this.translateService.currentLang || 'fr';
    switch (currentLang) {
      case 'fr': return nomFR || nomEN || nomES;
      case 'en': return nomEN || nomFR || nomES;
      case 'es': return nomES || nomFR || nomEN;
      default: return nomFR || nomEN || nomES;
    }
  }
}
